module.exports = __webpack_public_path__ + "img/bag-disabled.9f83ff44.svg";